import React from 'react';

function tryLock() {
  const so = (window.screen as any)?.orientation;
  if (so?.lock) {
    so.lock('portrait').catch(() => {});
  }
}

export default function PortraitOnly() {
  return (
    <div className="portrait-lock" aria-hidden="true">
      <div className="portrait-lock-card">
        <div className="portrait-lock-title">Rotate your device</div>
        <div className="portrait-lock-text">the app works best in portrait mode.</div>
        <button type="button" className="tool-button" onClick={tryLock}>
          Try to lock to portrait
        </button>
      </div>
    </div>
  );
}